module.exports = __webpack_public_path__ + "static/media/product-sans.7b32fa54.ttf";